import React from 'react';
import type { FC } from 'react';
import { Card, styled } from '@material-ui/core';
import { theme } from '../theme/mui-theme';
import Tags from './Tags';
import { getNoteTags } from '../services/utils/tags';
import { CustomerNoteModel } from '@/models/customer';
import { formatDate } from '@/services/utils/date-time';

interface Props {
  readonly note: CustomerNoteModel;
}

const CardStyled = styled(Card)({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.spacing(1),
  padding: theme.spacing(2),
  boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)'
});

const Footer = styled('div')({
  display: 'flex',
  columnGap: theme.spacing(3),
  color: '#909090',
  fontSize: '12px'
});

const CustomerNoteCard : FC<Props> = ({ note }) => {
  const { id, content, createdAt } = note;
  const email = note.createdByUser?.email ?? null;
  const formattedDate = formatDate(createdAt, 'dd.MM.yyyy');

  const noteTags = getNoteTags(note).map(tag => ({
    label: tag
  }));

  return (
    <CardStyled data-id={id}>
      <Tags tags={noteTags} />

      <div>
        { content }
      </div>

      <Footer>
        <span>
          { formattedDate }
        </span>

        <span>
          { email }
        </span>
      </Footer>
    </CardStyled>
  );
};

export default CustomerNoteCard;
